export default "__VITE_ASSET__d8f79dcf__"